<ion-content>
  <app-header [title]="'Handheld Setting Admin'"></app-header>
  <div class="loading-container" style="padding-top:10%"  *ngIf="!loading">
      <ion-spinner></ion-spinner>
  </div>
  <ion-content class="ion-padding">
  <ion-grid >
    <form>

      <ion-row class="form-row" *ngFor="let set of systemSetting; let i = index">
        <ion-col size="12" size-md="4" class="label-cell">
          <b>{{set.displayName}}</b>
          <div class="helper-text">
            {{set.subDisplayText}}
          </div>
        </ion-col>
       <ion-col size="12" [attr.size-md]="set.size" *ngIf="set.name === 'RouteHH_Test_Mode'">
         <div class="checkbox-column">
            <ion-checkbox slot="start" [value]="set.name" [checked]="set.data"  (ionChange)="toggleSelection(set, $event)"> </ion-checkbox>
        </div>
          </ion-col>
         <ion-col size="12" [attr.size-md]="set.size" *ngIf="set.name!='RouteHH_Test_Mode' && set.name!='RouteHH_Trucks'">
          <ion-row>
            <ion-input type="text"    [(ngModel)]="set.data"  [name]="'setting_' + i" placeholder=""></ion-input>
            <span class="inline-suffix">{{set.extra}}</span>
            </ion-row>
        </ion-col>
          <ion-col size="12" [attr.size-md]="set.size" *ngIf="set.name=='RouteHH_Trucks'">
          <ion-row>
            <ion-textarea type="text"    [(ngModel)]="set.data"  [name]="'setting_' + i" placeholder=""></ion-textarea>
            <span class="inline-suffix">{{set.extra}}</span>
            </ion-row>
        </ion-col>
      </ion-row>
      <ion-row class="ion-justify-content-center ion-padding-top">
        <ion-button color="gallaghergreen" type="submit" (click)="submitForm()">Submit</ion-button>
      </ion-row>
    </form>
  </ion-grid>
</ion-content>
</ion-content>
